export default __webpack_public_path__ + "static/media/Materiality_Policy_2.4427dd54.pdf";